// extracted by mini-css-extract-plugin
module.exports = {"container":"cms-page-list_container__V6TCo","item":"cms-page-list_item__tj40y","link":"cms-page-list_link____AUf"};